import { portalText, portalLocale } from "../../../i18n/portal.js";
/**
 * The Organization pages' words for roles and moments (plan-014 B2). Copy only: every decision is the API's and the
 * capability module's (`@wetalk/domain`'s `capability.ts`).
 */
import type { AccountRole } from "@wetalk/domain";

import type { WorkspaceRoleView } from "../../../api/gateway.js";

/** Organization roles, as the console names them (design §27.5.2). */
export const ACCOUNT_ROLE_WORD: Readonly<Record<AccountRole, string>> = {
  get owner() { return portalText("core", "account_admin.owner_89ff31"); },
  get admin() { return portalText("core", "account_admin.admin_4e7afe"); },
  get finance() { return portalText("core", "account_admin.finance_1b48d3"); },
  get viewer() { return portalText("core", "account_admin.viewer_dbad9f"); },
};

/** Workspace roles, as the console names them (design §27.5.3). */
export const WORKSPACE_ROLE_WORD: Readonly<Record<WorkspaceRoleView, string>> = {
  get owner() { return portalText("core", "account_admin.owner_89ff31"); },
  get admin() { return portalText("core", "account_admin.admin_4e7afe"); },
  get member() { return portalText("core", "account_admin.member_6853c9"); },
  get viewer() { return portalText("core", "account_admin.viewer_dbad9f"); },
  get developer() { return portalText("core", "account_admin.developer_7e08eb"); },
  get campaign_manager() { return portalText("core", "account_admin.campaign_manager_ce843f"); },
  get billing() { return portalText("core", "account_admin.billing_abaec4"); },
};

const DAY_MS = 86_400_000;

function SHORT_DATE(): Intl.DateTimeFormat { return new Intl.DateTimeFormat(portalLocale() === "en" ? "en-GB" : "el-GR", { day: "numeric", month: "short" }); }

/** "14 Sep" — a past or future day, short. */
export function shortDateText(iso: string): string {
  return SHORT_DATE().format(new Date(iso));
}

/** "expires in 5 days", "expires today", "expired 14 Sep". */
export function expiryText(expiresAt: string, now: Date): string {
  const left = new Date(expiresAt).getTime() - now.getTime();
  if (left <= 0) return portalText("core", "account_admin.expired_38ee3f", { value0: shortDateText(expiresAt) });
  const days = Math.floor(left / DAY_MS);
  if (days === 0) return portalText("core", "account_admin.expires_today_3c1f7d");
  return days === 1 ? portalText("core", "account_admin.expires_in_1_day_6cfcde") : portalText("core", "account_admin.expires_in_days_8cbf16", { value0: String(days) });
}

/** How someone signs in, as the People table says it ("Password + authenticator", "Google, no MFA"). */
export function signInText(signIn: { readonly password: boolean; readonly authenticator: boolean; readonly external: readonly string[] }): string {
  const ways = [
    ...(signIn.password ? [portalText("core", "auth.password_8be3c9")] : []),
    ...signIn.external.map((one) => (one === "google" ? portalText("core", "account_admin.google_2b681c") : portalText("core", "auth.microsoft_11f324"))),
  ];
  if (ways.length === 0) return signIn.authenticator ? portalText("core", "account_admin.authenticator_4853c8") : portalText("core", "account_admin.no_sign_in_yet_b53d75");
  const named = ways.join(", ");
  if (signIn.authenticator) return portalText("core", "account_admin._authenticator_0a6577", { value0: named });
  return signIn.password && ways.length === 1 ? named : portalText("core", "account_admin._no_mfa_d05fc1", { value0: named });
}
